import { useQuery } from '@tanstack/react-query';
import type { GuestNonScriptRangeBundlesProps } from '../../interface/interface';
import Loading from '../Loading';
import GuestProductCards from './GuestProductCards';
import { getGuestBundledAccessories } from '../../service/getGuestBundledAccessories';

export default function GuestNonScriptRangeBundles(
  props: GuestNonScriptRangeBundlesProps,
) {
  const { data, isLoading, error } = useQuery({
    queryKey: ['guest-bundled-accessories'],
    queryFn: async () => {
      return await getGuestBundledAccessories();
    },
    retry: 1,
  });

  if (isLoading || props.loading) return <Loading />;

  if (error) {
    console.error('Query error:', error);
    return <p>Error loading bundled accessories</p>;
  }

  return (
    <div className="result-block-container">
      <ul className="grid grid-cols-1 gap-6 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-4">
        {data?.length ? (
          data?.map((product: any, index: number) => (
            <div key={index}>
              <GuestProductCards
                addProductToCart={async (id: string) => {
                  await props.addToCartMutation.mutateAsync(id);
                }}
                removeProductFromCart={async (productId: string) => {
                  await props.removeFromCartMutation.mutateAsync(productId);
                }}
                product={product}
                substitueCard={false}
                isAccessories={true}
                allowedProduct={false}
              />
            </div>
          ))
        ) : (
          <p>No Non-Script Range Bundled Products Exist</p>
        )}
      </ul>
    </div>
  );
}
